"use client";

import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { Menu } from "@mui/material";
import React from "react";

import { IWorkflowStep } from "@/interfaces/workflow-step.interface";
import { WorkflowEditDialogMessages } from "@/messages/workflow/workflow-edit-dialog.messages";
import NotificationItem from "@/mui/Items/NotificationItem";

interface WorkflowStepPopoverProps {
  isOpen: boolean;
  anchorEl: (EventTarget & HTMLButtonElement) | null;
  onClose: () => void;
  messages: WorkflowEditDialogMessages;
  selectedWorkflowStep: IWorkflowStep;
  handleOpenDialog: (isEditing: boolean, step?: IWorkflowStep) => void;
  setWorkflowStep: React.Dispatch<React.SetStateAction<IWorkflowStep | null>>;
  isAdmin?: boolean;
  onRemove?: (step: IWorkflowStep) => void;
  isLoading?: boolean;
}

export function WorkflowStepPopover({
  isOpen,
  anchorEl,
  onClose,
  messages,
  selectedWorkflowStep,
  handleOpenDialog,
  setWorkflowStep,
  isAdmin = false,
  onRemove,
}: WorkflowStepPopoverProps) {
  const { updatePopover, removeWorkflowStepPopover } = messages;

  const handleEditClick = () => {
    handleOpenDialog(true);
    setWorkflowStep(selectedWorkflowStep);
    onClose();
  };

  const handleDeleteClick = () => {
    if (onRemove) {
      onRemove(selectedWorkflowStep);
    }
    onClose();
  };

  return (
    <Menu
      open={isOpen}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
    >
      <NotificationItem
        icon={<EditIcon />}
        onClick={handleEditClick}
        title={updatePopover}
      />
      {isAdmin && (
        <NotificationItem
          icon={<DeleteIcon />}
          onClick={handleDeleteClick}
          title={removeWorkflowStepPopover}
        />
      )}
    </Menu>
  );
}
